import { Mutation } from 'graphql/generated/graphqlTypes';

export function mockedDeleteDoorByIdData(deleteDoorById: string | null): Pick<Mutation, 'deleteDoorById'> {
  return {
    deleteDoorById
  };
}

export const mockedDeleteDoorByIdDataForMutation = mockedDeleteDoorByIdData('mockedDoorId0');
export const mockedDeleteDoorByIdDataForMutation1 = mockedDeleteDoorByIdData('mockedDoorId1');
